import { BusinessIndicatorPipe } from '@/features/business-indicators/business-indicator.pipe';
import { UiFieldComponent } from '@/ui/field/ui-field';
import { UiSectionContentComponent } from '@/ui/section/section-content/ui-section-content';
import { UiSectionComponent } from '@/ui/section/ui-section';
import { UiSelectComponent } from '@/ui/select/ui-select';
import { UiToggleComponent } from '@/ui/toggle/ui-toggle';
import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { Component, effect, inject, input, linkedSignal, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { AbstractTailoredWidgetTemplateEditor } from '../../../../components/template-widgets/AbstractTailoredWidgetEditorTemplate.class';
import { AdvizeoInputDirective } from '../../../../directives/advizeo-input/advizeo-input.directive';
import type { BusinessIndicatorId } from '../../../../interfaces/BusinessIndicator.interface';
import { BusinessIndicatorsProvider } from '../../../../providers/business-indicator/business-indicators.provider';
import type { BusinessIndicatorAdvancementConfig } from '../widgets-business-indicators.service';

@Component({
    selector: 'template-widget-business-indicator-advancement',
    imports: [
        BusinessIndicatorPipe,
        ReactiveFormsModule,
        TranslatePipe,
        UiFieldComponent,
        UiSectionComponent,
        UiSectionContentComponent,
        UiSelectComponent,
        UiToggleComponent,
        FormsModule,
        AdvizeoInputDirective
    ],
    templateUrl: './template-widget-business-indicator-advancement-editor.component.html',
    styleUrl: './template-widget-business-indicator-advancement-editor.component.scss'
})
export class TemplateWidgetBusinessIndicatorAdvancementEditorComponent extends AbstractTailoredWidgetTemplateEditor<BusinessIndicatorAdvancementConfig> {
    private _businessIndicatorsOldProvider = inject(BusinessIndicatorsProvider);

    formInputs = input<BusinessIndicatorAdvancementConfig>();

    config = output<{
        isValid: boolean;
        formValues: BusinessIndicatorAdvancementConfig;
    }>();

    businessIndicatorsIds = toSignal(
        this._businessIndicatorsOldProvider
            .getAllowedBusinessIndicatorIds$()
            .pipe(filter(businessIndicator => businessIndicator?.length > 0)),
        { initialValue: [] }
    );

    displayLegend = linkedSignal(() => this.formInputs()?.displayLegend ?? true);

    selectedBusinessIndicatorId = linkedSignal<BusinessIndicatorId | null>(() => {
        const businessIndicatorId = this.formInputs()?.businessIndicatorId;
        return businessIndicatorId ? businessIndicatorId : this.businessIndicatorsIds()[0];
    });

    isEstimated = linkedSignal<boolean>(() => {
        const isEstimated = this.formInputs()?.isEstimated;
        return isNotNullish(isEstimated) ?? true;
    });

    title = linkedSignal(() => {
        const formInputs = this.formInputs();
        const selectedBusinessIndicatorId = this.selectedBusinessIndicatorId();

        return (
            formInputs?.title ||
            (selectedBusinessIndicatorId &&
                this._businessIndicatorsOldProvider.getBusinessIndicatorById(selectedBusinessIndicatorId).name) ||
            ''
        );
    });
    constructor() {
        super();

        effect(() => {
            const businessIndicatorId = this.selectedBusinessIndicatorId();
            const isEstimated = this.isEstimated();
            const displayLegend = this.displayLegend();
            const title = this.title();

            if (businessIndicatorId) {
                this.config.emit({
                    isValid: true,
                    formValues: {
                        businessIndicatorId: businessIndicatorId,
                        isEstimated: isEstimated,
                        displayLegend: displayLegend,
                        title: title
                    }
                });
            }
        });
    }
}
